import { FC, ReactNode } from 'react';
import { Avatar, Typography } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';

interface WhitelabelSectionCardProps {
    children: ReactNode;
    description: ReactNode;
    icon: ReactNode;
    title: string;
}

const WhitelabelSectionCard: FC<WhitelabelSectionCardProps> = ({ children, description, icon, title }): JSX.Element => {
    const { token } = useAntDesignTheme();

    return (
        <section
            style={{
                backgroundColor: token.colorBgContainer,
                border: `1px solid ${token.colorBorder}`,
                borderRadius: token.borderRadius,
                padding: '1rem',
            }}
        >
            <Typography.Title
                level={5}
                style={{ alignItems: 'center', display: 'flex', gap: '0.375rem', marginBottom: '0.25rem' }}
            >
                <Avatar
                    icon={
                        <span
                            style={{
                                alignItems: 'center',
                                display: 'inline-flex',
                                justifyContent: 'center',
                                lineHeight: 0,
                                transform: 'scale(0.75)',
                            }}
                        >
                            {icon}
                        </span>
                    }
                    shape='square'
                    size={20}
                    style={{
                        backgroundColor: token.colorBgBase,
                        border: `1px solid ${token.colorBorder}`,
                        color: token.colorTextTertiary,
                        flex: '0 0 auto',
                    }}
                />
                <span>{title}</span>
            </Typography.Title>
            <Typography.Paragraph style={{ color: token.colorTextTertiary, marginBottom: '1rem' }}>
                {description}
            </Typography.Paragraph>
            {children}
        </section>
    );
};

export default WhitelabelSectionCard;
